import React from "react";
import iopexLogo from "../assets/images/iopex.webp";
import checkIcon from "../assets/icons/fi_14090371.svg"; 

function WhyUs() {
  const rows = [
    ["Strategy", "Strong", "Weak", "Limited", "End-to-End"],
    ["Implementation", "Handoff to Others", "Own Product Only", "Campaign-Focused", "Full Stack"],
    ["Operations at Scale", "Not their Model", "Support Only", "Siloed Teams", "$6.8B Managed"],
    ["Technology", "Partner Network", "Own Product", "Limited Proprietary", "100+ Integrations"],
    ["Creative Production", "Not in Scope", "Not Their Focus", "Core Strength", "3.5M+ Assets"],
    ["Retail Media Expertise", "General Consulting", "Product-Specific", "Buyer-Side Focus", "Seller-Side Expert"],
    ["Flexibility", "High Cost Model", "Vendor Lock-In", "Agency Model", "Modular Services"],
    ["AI & Automation", "Emerging", "Product Features", "Tools Only", "Agentic AI Ops"],
  ];

  return (
    <div className="whyus-page">
      {/* 🔹 Top Logo */}
      <header className="whyus-header">
        <img src={iopexLogo} alt="iOPEX Logo" className="whyus-logo" />
      </header>

      {/* 🔸 Title */}
      <h1 className="whyus-title">iOPEX Vs. Other Partners</h1>

      {/* 🧩 Table */}
      <div className="whyus-table-wrapper">
        <table className="whyus-table">
          <thead>
            <tr>
              <th>Dimension</th>
              <th>Management Consultants</th>
              <th>Ad Tech Vendors</th>
              <th>Agency Holding Companies</th>
              <th>iOPEX</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                {row.map((col, i) => (
                  <td key={i}>
                    {i === 4 ? (
                      <div className="iopex-cell">
                        <img src={checkIcon} alt="✔" className="check-icon" />
                        <span>{col}</span>
                      </div>
                    ) : (
                      col
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default WhyUs;
